import Element from "config/routes/Element";
import RedirectToRoute from "config/routes/RedirectToRoute";
import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import LoadingPage from "views/Base/LoadingPage";
import { ACCOUNTING_FIRM_ROUTES as ROUTES } from "./utils/accountingFirmRoutes";

const AccountingFirmDetail = lazy(() => import("views/AccountingFirm"));
const AccountingFirmsList = lazy(() => import("views/AccountingFirm/AccountingFirmsList"));
const AddAccountingFirm = lazy(() => import("views/AccountingFirm/AddAccountingFirm"));
const Addons = lazy(() => import("views/AccountingFirm/Addons"));
const Addresses = lazy(() => import("views/AccountingFirm/Addresses"));
const Banks = lazy(() => import("views/AccountingFirm/Banks"));
const Companies = lazy(() => import("views/AccountingFirm/Companies"));
const Contacts = lazy(() => import("views/AccountingFirm/Contacts"));
const CounterpartSsiRules = lazy(() => import("views/AccountingFirm/Settings/CounterpartSsiRules"));
const CustomGraphics = lazy(() => import("views/AccountingFirm/CustomGraphics"));
const ExpensesCategories = lazy(() => import("views/AccountingFirm/Settings/ExpensesCategories"));
const GeneralSettings = lazy(() => import("views/AccountingFirm/Settings"));
const Info = lazy(() => import("views/AccountingFirm/Info"));
const PaymentMethods = lazy(() => import("views/AccountingFirm/PaymentMethods"));
const Platforms = lazy(() => import("views/AccountingFirm/Platforms"));

export const accountingFirmRoutes = (
  <Route path={ROUTES.accountingFirms}>
    <Route
      index
      element={
        <Element requiredPermission="displayAccountingFirms">
          <AccountingFirmsList />
        </Element>
      }
    />

    <Route
      path={ROUTES.add}
      element={
        <Element requiredPermission="createAccountingFirms">
          <AddAccountingFirm />
        </Element>
      }
    />

    <Route
      path={ROUTES.accountingFirmDetail}
      element={
        <Suspense fallback={<LoadingPage />}>
          <AccountingFirmDetail />
        </Suspense>
      }
    >
      <Route index element={<RedirectToRoute route={ROUTES.info} />} />
      <Route
        path={ROUTES.info}
        element={
          <Element requiredPermission="displayAccountingFirms">
            <Info />
          </Element>
        }
      />
      <Route
        path={ROUTES.banks}
        element={
          <Element requiredPermission="canDisplayAccountingBanks">
            <Banks />
          </Element>
        }
      />
      <Route
        path={ROUTES.address}
        element={
          <Element requiredPermission="canDisplayAccountingAdress">
            <Addresses />
          </Element>
        }
      />
      <Route
        path={ROUTES.contacts}
        element={
          <Element requiredPermission="canDisplayAccountingContacts">
            <Contacts />
          </Element>
        }
      />
      <Route
        path={ROUTES.platform}
        element={
          <Element requiredPermission="canDisplayAccountingPlatforms">
            <Platforms />
          </Element>
        }
      />
      <Route
        path={ROUTES.addons}
        element={
          <Element requiredPermission="canDisplayAccountingServices">
            <Addons />
          </Element>
        }
      />
      <Route
        path={ROUTES.companies}
        element={
          <Element requiredPermission="canDisplayAccountingCompanies">
            <Companies />
          </Element>
        }
      />

      <Route path={ROUTES.settings} element={<RedirectToRoute route={ROUTES.settingsGeneral} />} />
      <Route
        path={ROUTES.settingsGeneral}
        element={
          <Element requiredPermission="canDisplayAccountingSettings">
            <GeneralSettings />
          </Element>
        }
      />
      <Route
        path={ROUTES.settingsPaymentMethods}
        element={
          <Element requiredPermission="canDisplayAccountingSettings">
            <PaymentMethods />
          </Element>
        }
      />
      <Route
        path={ROUTES.settingsExpensesCategories}
        element={
          <Element requiredPermission="canDisplayAccountingSettings">
            <ExpensesCategories />
          </Element>
        }
      />
      <Route
        path={ROUTES.settingsCustomGraphics}
        element={
          <Element requiredPermission="canDisplayAccountingSettings">
            <CustomGraphics />
          </Element>
        }
      />
      <Route
        path={ROUTES.settingsCounterpartSsiRules}
        element={
          <Element requiredPermission="canManageCounterpartSsiRules">
            <CounterpartSsiRules />
          </Element>
        }
      />

      <Route path="*" element={<RedirectToRoute route={ROUTES.info} />} />
    </Route>
  </Route>
);
